import { LicenseInfo } from '@mui/x-license-pro'
import { BrowserTracing } from '@sentry/browser'
import * as Sentry from '@sentry/react'
import { Amplify } from 'aws-amplify'
import React from 'react'
import ReactDOM from 'react-dom/client'
import TagManager from 'react-gtm-module'

import { App } from 'app'

function getExistingCognitoClientId(): string | undefined {
  try {
    // Infer from Amplify/Cognito localStorage namespace keys.
    // Keys commonly look like: CognitoIdentityServiceProvider.<clientId>.<username>.*
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (!key) continue
      const m = key.match(/^CognitoIdentityServiceProvider\.([^.]+)\./)
      if (m?.[1]) return m[1]
    }
  } catch {
    // ignore storage access errors
  }

  return undefined
}

const cognitoClientId = getExistingCognitoClientId() || import.meta.env.VITE_COGNITO_CLIENT_ID

TagManager.initialize({
  gtmId: import.meta.env.VITE_GTM_ID,
  preview: import.meta.env.VITE_GTM_PREVIEW,
  auth: import.meta.env.VITE_GTM_AUTH,
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT || 'dev',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 0.01,
})

// const intercomAppId = window.env?.INTERCOM_APP_ID || ''
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: import.meta.env.VITE_AWS_REGION,
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    userPoolWebClientId: cognitoClientId,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    oauth: {
      domain: import.meta.env.VITE_COGNITO_DOMAIN,
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: '/',
      redirectSignOut: '/',
      responseType: 'code',
    },
  },
})
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_COMPONENTS)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
